import ListTable from "common/ListTable";
import { useMemo, useState } from "react";
import CustomFilter from "../../../Common/CustomFilter";

const UserListTable = (props) => {
  const { total, loading, defaultCurrent, pageSize, current, onChange } = props;
  const [showFilter, setShowFilter] = useState(false);

  const handleFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const memoizedCustomFilter = useMemo(
    () => (
      <CustomFilter
        showFilter={showFilter}
        handleFilter={handleFilter}
        tableData={props.dataSource}
        fetchTableData={null}
        filterName="buying_office"
      />
    ),
    [showFilter],
  );

  return (
    <>
      {props.filter && <>{memoizedCustomFilter}</>}
      <div className="table" style={{ marginTop: 10 }}>
        <ListTable
          bordered
          loading={loading}
          emptyText="No records to show yet."
          pagination={{
            showSizeChanger: false,
            defaultPageSize: pageSize,
            current: current,
            onChange: onChange,
            defaultCurrent: defaultCurrent,
            total: total,
          }}
          columns={props.tableColumns}
          dataSource={props.dataSource}
        />
      </div>
    </>
  );
};
export default UserListTable;
